import React from 'react';
import { ordersRatingStore } from '../OrdersRatingScreen/store/ordersRatingStore';
import CheckoutScreen from './CheckoutScreen';
import { CheckoutStoreContext } from './context';
import { ordersHistoryStore } from '~/mobx/ordersHistoryStore/ordersHistoryStore';
import { callCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { liveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';
import { CheckoutStore } from '~/mobx/checkoutStore';

const historyCheckoutStore = new CheckoutStore(ordersHistoryStore);
const callCenterCheckoutStore = new CheckoutStore(callCenterStore);
const liveOrdersCheckoutStore = new CheckoutStore(liveOrdersStore);
const ordersRatingCheckoutStore = new CheckoutStore(ordersRatingStore);

export const LiveOrdersCheckoutScreen = () => (
  <CheckoutStoreContext.Provider value={{ store: liveOrdersCheckoutStore }}>
    <CheckoutScreen />
  </CheckoutStoreContext.Provider>
);

export const CallCenterCheckoutScreen = () => (
  <CheckoutStoreContext.Provider value={{ store: callCenterCheckoutStore }}>
    <CheckoutScreen />
  </CheckoutStoreContext.Provider>
);

export const HistoryCheckoutScreen = () => (
  <CheckoutStoreContext.Provider value={{ store: historyCheckoutStore }}>
    <CheckoutScreen />
  </CheckoutStoreContext.Provider>
);

export const OrdersRatingCheckoutScreen = () => (
  <CheckoutStoreContext.Provider value={{ store: ordersRatingCheckoutStore }}>
    <CheckoutScreen />
  </CheckoutStoreContext.Provider>
);
